module.exports = require("core-js/library/fn/symbol");


//////////////////
// WEBPACK FOOTER
// external "core-js/library/fn/symbol"
// module id = 15
// module chunks = 0